import { j as t } from "../../jsx-runtime-CZlWR0BA.js";
import { H as a, U as n } from "../../styled-components.browser.esm-CdvvWRMU.js";
const r = (e) => n`
  0% { opacity: ${e.theme.opacityIntense}; }
  50% { opacity: ${e.theme.opacityLight}; }
  100% { opacity: ${e.theme.opacityIntense}; }
`, l = a.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  border-radius: ${(e) => e.theme.borderRadiusMd};
  background: ${(e) => e.theme.colorNeutralMedium};
  opacity: ${(e) => e.theme.opacityIntense};
  animation: ${r} 1s infinite;
  animation-timing-function: ease-out;
`, s = ({ role: e = "alert", ...o }) => /* @__PURE__ */ t.jsx(l, { role: e, "aria-label": "cargando", "aria-busy": "true", "aria-live": "polite", ...o }), u = s, c = ({ loading: e, skeleton: o, children: i }) => e ? /* @__PURE__ */ t.jsx(t.Fragment, { children: o }) : /* @__PURE__ */ t.jsx(t.Fragment, { children: i }), h = c;
export {
  u as Skeleton,
  h as SkeletonPlaceHolder
};
